import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import DarkModeToggle from '../components/DarkModeToggle';

const Home = () => {
  const [readingTypes, setReadingTypes] = useState([]);
  const [selectedReadingType, setSelectedReadingType] = useState('');
  const navigate = useNavigate();

  // Fetch reading types from Supabase on component mount
  useEffect(() => {
    const fetchReadingTypes = async () => {
      try {
        const { data, error } = await supabase.from('reading_type').select('*');
        if (error) {
          console.error('Error fetching reading types:', error);
        } else {
          setReadingTypes(data);
        }
      } catch (err) {
        console.error('Unexpected error:', err);
      }
    };

    fetchReadingTypes();
  }, []);

  const handleStartReading = () => {
    if (selectedReadingType) {
      navigate('/reading-session', { state: { selectedReadingType } });
    } else {
      alert('Please select a reading type to proceed.');
    }
  };

  return (
    <div className="home-container py-12 max-w-md mx-auto min-h-screen bg-white dark:bg-[#1a1a1a]">
      {/* Dark mode toggle positioned in top right */}
      <div className="absolute top-6 right-6">
        <DarkModeToggle />
      </div>
      
      <img alt="TarotMap" src="/favicon.ico" className="mx-auto h-10 w-auto" />
      <h2 className="text-l mt-6 font-semibold text-neutral-700 dark:text-[#D4D4D4] text-center mb-4">Welcome to TarotMap</h2>
      <p className="text-center text-sm text-neutral-600 dark:text-[#E7E7E7] mt-20 mb-10">Select a reading type to begin:</p>

      {/* Dropdown for selecting reading type */}
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="bg-white dark:bg-[#2F2F2F] px-8 py-10 sm:rounded-lg sm:px-12 shadow-sm dark:shadow-gray-900/20">
          <select
            value={selectedReadingType}
            onChange={(e) => setSelectedReadingType(e.target.value)}
            className="rounded-lg text-sm w-full mb-4 p-3 border-neutral-300 dark:border-neutral-600 bg-white dark:bg-[#3A3A3A] text-gray-900 dark:text-[#E7E7E7] focus:ring-neutral-500/20 dark:focus:ring-neutral-500/20 hover:bg-neutral-100 dark:hover:bg-[#404040] focus:border-none"
          >
            <option value="" disabled>
              Reading types
            </option>
            {readingTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.id}
              </option>
            ))}
          </select>
          <button
            type="button"
            onClick={handleStartReading}
            className="mt-4 flex w-full justify-center rounded-full bg-transparent text-neutral-900 dark:text-[#D4D4D4] text-base font-regular ring-1 ring-neutral-900 dark:ring-[#D4D4D4] hover:bg-neutral-900 hover:text-white dark:hover:bg-white dark:hover:text-neutral-900 hover:ring-neutral-900 dark:hover:ring-white px-3 py-2"
          >
            Start Reading
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;